import { defineAsyncComponent } from 'vue'
export default {
  "components-app-bar": defineAsyncComponent(() => import("/app/layouts/components/AppBar.vue").then(m => m.default || m)),
  "components-footer": defineAsyncComponent(() => import("/app/layouts/components/Footer.vue").then(m => m.default || m)),
  "components-user-profile-menu-button": defineAsyncComponent(() => import("/app/layouts/components/UserProfileMenuButton.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m))
}